import { useQuery } from '@tanstack/react-query';
import { VisualizationRanksApi } from '@/features/visualizations/api/visualizationRanks';
import { visualizationQueryKeys } from '@/features/visualizations/queryKeys';

export const useVisualizationItemRanks = ({
  viewId,
  visualizationId,
  enabled = true,
}: {
  viewId: number;
  visualizationId: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: visualizationQueryKeys.itemRanks.detail(viewId, visualizationId),
    queryFn: async () => {
      const entries = await VisualizationRanksApi.getItemRanks(viewId, visualizationId);
      const map = new Map<number, string>();
      for (const entry of entries) {
        map.set(entry.itemId, entry.rank);
      }
      return map;
    },
    enabled,
    refetchOnMount: false,
  });
};
